import React from 'react';
import styled from 'react-emotion';
import ContentItem from '../index';

const ListItem = styled.li`
`;

export default (props) => {
  const { content = [] } = props;
  return (
    <ListItem>
      {content.map(item => (
        <ContentItem key={item.id} {...item} />
      ))}
    </ListItem>
  );
};
